'use client';

import { MouseEvent } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getBgClassNames } from '@nx-frontend/shared/themes';
import { FileBreadcrumbType, PortalBgType, PortalClassState, ThemeColorSchemas } from '@nx-frontend/shared/types';

interface FileProgressListItemProps {
  type: FileBreadcrumbType;
  name: string;
  url: string;
  themeColors: ThemeColorSchemas;
}

export const FileDestination: React.FC<FileProgressListItemProps> = ({ name, url, themeColors }) => {
  const onLinkClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(url, '_blank');
  };
  return (
    <div className="flex pr-2 max-w-full items-center justify-center text-[10px] font-semibold text-gray-400 whitespace-nowrap leading-4">
      <div className="mr-1">
        <Icon icon={IconsMap.DOCUMENT} className="h-3 w-3" />
      </div>
      <Link
        className={classNames(
          'text-ellipsis overflow-hidden rounded-md px-0.5',
          ...getBgClassNames(themeColors, PortalBgType.SURFACE_INNER_HOVER_2, [PortalClassState.HOVER])
        )}
        href={url}
        title={name}
        target="_blank"
        onClick={onLinkClick}
      >
        {name}
      </Link>
    </div>
  );
};
